import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { signIn } from "../services/authService";
import EmailNotVerified from "../components/EmailNotVerified";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user, loading } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (isSubmitting) return;
    setIsSubmitting(true);

    const result = await signIn(email, password);

    if (!result.ok) {
      setError(result.error);
    }

    setIsSubmitting(false);
  };

  if (loading) return <p className="p-6 text-center">Loading...</p>;
  if (user && user.emailVerified) return <Navigate to="/dashboard" />;

  if (user && !user.emailVerified) {
    return <EmailNotVerified user={user} />;
  }

  return (
    <div className="min-h-screen w-full flex flex-col items-center bg-[#fcf9f7] gap-9">
      {/* Header with gradient */}
      <div className="w-full flex flex-col items-center relative pb-16">
        <div className="relative w-full max-w-md">
          <img
          src="/header.png"
         className="w-full h-[367px]  block object-cover "/>
         <div className="">
          <img 
            src="/BodyOwn_Logo.png" 
            alt="bodyown" 
             className="absolute left-1/2 -translate-x-1/2 bottom-[100px] w-72  object-contain brightness-0 invert"

          />
          <p
      className="absolute left-1/2 -translate-x-1/2 bottom-[64px] text-xl font-semibold text-white text-center"
      style={{ fontFamily: "DM Sans, sans-serif" }}
    >
      Healing After Birth
    </p>
    </div>
          
        
        </div>
        
        
      </div>

      {/* Form wrapper */}
      <div className="w-full max-w-[680px] px-6 flex flex-col gap-16">
        {/* Form container */}
        <div className="w-full flex flex-col gap-6 pb-3 border-b border-[#b2b2b2]">
          {error && (
            <div className="p-3 bg-red-100 rounded-lg">
              <p className="text-red-800 text-sm m-0">{error}</p>
            </div>
          )}

          <form onSubmit={handleLogin} className="flex flex-col gap-6">
            {/* Email input */}
            <div className="flex flex-col gap-1.5">
              <label 
                className="font-medium text-base text-[#0c2624] tracking-[0.4px]"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Email
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-base text-[#1e1e1e] placeholder:text-[#b3b3b3] outline-none transition-all focus:border-[#1e5e5b] focus:ring-[3px] focus:ring-[#1e5e5b]/10"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              />
            </div>

            {/* Password input */}
            <div className="flex flex-col gap-1.5">
              <label 
                className="font-medium text-base text-[#0c2624] tracking-[0.4px]"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Password
              </label>
              <input
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-base text-[#1e1e1e] placeholder:text-[#b3b3b3] outline-none transition-all focus:border-[#1e5e5b] focus:ring-[3px] focus:ring-[#1e5e5b]/10"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              />
            </div>

            {/* Action buttons */}
            <div className="flex flex-col gap-2">
              <button 
                type="submit"
                disabled={isSubmitting}
                className={`w-full py-4 border-0 rounded-full font-semibold text-base transition-all ${
                  isSubmitting
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-[#1e5e5b] text-white cursor-pointer hover:bg-[#164b49] hover:-translate-y-0.5 hover:shadow-lg"
                }`}
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                {isSubmitting ? "Signing in…" : "Sign in"}
              </button>
              <Link
                  to="/forgot-password"
                   className="w-full py-4 bg-transparent border-0 text-[#1e5e5b] font-semibold text-base underline cursor-pointer transition-opacity hover:opacity-70 inline-block text-center"
                   style={{ fontFamily: "DM Sans, sans-serif" }}
                   >
  Forgot password
</Link>
            </div>
          </form>
        

        {/* Sign up section */}
        <div className="w-full flex flex-col items-center gap-4">
          <p 
            className="font-semibold text-base text-[#1e1e1e] m-0"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            First time at BodyOwn?
          </p>
          <Link 
            to="/signup" 
            className="w-full py-4 bg-white border border-[#1e5e5b] rounded-full text-[#1e5e5b] font-semibold text-base text-center no-underline cursor-pointer transition-all hover:bg-[#f0f9f8] block"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Sign up
          </Link>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Login;